import {showGlobalErrorToast} from './httpCompUtil'
import {storePersistKey} from "@/plugins/tools/Constant";
import router from "@/router";
import {MessageBox} from "element-ui";
import store from '@/store' // progress bar style


export default (response) => {
  // 业务状态码-判断
  switch (response.data && response.status) {
    case 401: // 401: 未登录
    case 424: // 401: 未登录
        MessageBox.confirm('令牌状态已过期，请点击重新登录', '系统提示', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            store.dispatch('LogOut').then(() => {
              // 刷新登录页面，避免多次弹框
              window.location.reload()
            })
          })
          .catch(() => {})
      break;
    case 403: // 403 token过期
      showGlobalErrorToast(response, '登录过期，请重新登录');
      break;
    case 404: // 404请求不存在
      showGlobalErrorToast(response, '请求的资源不存在');
      break;
    case 500:
    case 501:
    case 502:
    case 503:
    case 504:
      showGlobalErrorToast(response, '服务器错误');
      break;
  }
}



// WEBPACK FOOTER //
// ./src/plugins/http/httpResponseFilter.js